import {
	Box,
	List,
	ListItemButton,
	ListItemText,
	Tooltip,
} from "@mui/material";
import { memo } from "react";

const OriginCell = memo(({ params }) => {
	const regex = /auto-generated-row-null/;

	return (
		<>
			<Box
				sx={{
					width: "100%",
					display: "grid",
					placeItems: "center",
					alignItems: "center",
					alignContent: "center",
					gap: "10px",
					p: 1.5,
				}}
			>
				{regex.test(params?.id) ? (
					<Box></Box>
				) : (
					<>
						<List sx={{ width: "100%" }} dense={true}>
							{params?.value?.map((origin, index) => (
								<Tooltip
									title={`${origin.user}-${origin.datasource}`}
								>
									<ListItemButton
										sx={{
											borderRadius: 5,
										}}
										key={`origin-${index}`}
									>
										<ListItemText
											primary={
												<Box
													sx={{
														overflowX: "hidden",
														textOverflow:
															"ellipsis",
														whiteSpace: "nowrap",
														width: "110px",
													}}
												>
													{`${origin.user}-${origin.datasource}`}
												</Box>
											}
										/>
									</ListItemButton>
								</Tooltip>
							))}
						</List>
					</>
				)}
			</Box>
		</>
	);
});

export { OriginCell };
